// extracted by mini-css-extract-plugin
module.exports = {"table-wrapper":"SearchTable_table-wrapper__35fH9","table":"SearchTable_table__3jWq9"};